import { BaseMapper, Undefinable } from '@ps/utils';
import {
  SurveyBaseQualification,
  SurveyQualification,
  SurveyQualificationDependency,
  SurveyRangeQualification,
  SurveySelectableQualification,
} from '@ps/survey-utils';

import {
  QualificationDependencyDto,
  SurveyQualificationDto,
  SurveyRangeQualificationDto,
  SurveySelectableQualificationDto,
} from '../dtos/survey-qualification.dto';

export class SurveyQualificationMapper extends BaseMapper<
  SurveyQualificationDto,
  SurveyQualification
> {
  public fromDto(dto: SurveyQualificationDto): SurveyQualification {
    if (dto.isRangeType === 1) {
      return this._rangeQualification(dto);
    }

    return this._selectableQualification(dto);
  }

  private _baseQualification(
    dto: SurveyQualificationDto,
  ): SurveyBaseQualification {
    return {
      qualificationCode: dto.qualification_code,
      qualificationName: dto.qualification_name,
      key: dto.key,
      isDefault: !!dto.isDefault,
      isAllSet: !!dto.isAllSet,
      isQuotaSet: !!dto.isQuotaSet,
      hasDependency: dto.hasDependency,
      dependency: this._mapDependency(dto.dependency),
      quotas: [],
    };
  }

  private _mapDependency(
    dependency: Undefinable<QualificationDependencyDto>,
  ): Undefinable<SurveyQualificationDependency> {
    if (!dependency) {
      return undefined;
    }

    return {
      respondentQuestionId: dependency.respondent_question_id,
      parentQualificationId: dependency.parentQualId,
      matchCriteria: dependency.matchCriteria,
      repeat: dependency.repeat,
      condition: dependency.condition,
    };
  }

  private _rangeQualification(
    dto: SurveyRangeQualificationDto,
  ): SurveyRangeQualification {
    return {
      ...this._baseQualification(dto),
      isRangeType: true,
      rangeSets: dto.range_sets.map((rangeSet) => ({
        from: rangeSet.from,
        to: rangeSet.to,
        units: rangeSet.units,
      })),
      data: dto.data.map((datum) => ({
        min: datum.mn,
        max: datum.mx,
        units: datum.units,
      })),
    };
  }

  private _selectableQualification(
    dto: SurveySelectableQualificationDto,
  ): SurveySelectableQualification {
    return {
      ...this._baseQualification(dto),
      isRangeType: false,
      conditionCodes: dto.condition_codes,
      data: dto.data.map((datum) => ({
        id: datum.id,
        name: datum.name,
      })),
    };
  }
}
